jQuery(function ($) {

  $('.js-floating-trigger').on('click', function () {
    if (window.innerWidth <= 1000) {
      $(this)
        .toggleClass('is-open')
        .next('.js-floating-target')
        .toggleClass('is-open');
    }
  });

});